const ProductElectronics = (props: { className?: string }) => (
  <svg width={40} height={40} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" className={props.className}>
    <path d="M18 36L20 16H30L18 36Z" fill="#E25317" />
    <path d="M22 4L20 24H10L22 4Z" fill="#E25317" />
  </svg>
);
export default ProductElectronics;
